import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { EmptyState } from "@/components/EmptyState";
import { Crown } from "lucide-react";

export default function SponsorsPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/sponsors", { params: { limit: 60 } }).then((r) => setItems(r.data.items || [])); }, []);
  return (
    <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="font-display text-3xl sm:text-4xl font-bold">Sponsors</h1>
      <p className="text-sm text-muted-foreground mt-1">Les partenaires qui soutiennent le sport polynésien.</p>
      <div className="mt-6">
        {items.length === 0 ? <EmptyState icon={Crown} title="Aucun sponsor référencé." description="Les entreprises partenaires des sportifs polynésiens apparaîtront ici." /> :
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {items.map((s) => (
              <Card key={s.id} className="p-4 aito-card-hover" data-testid="sponsor-logo">
                <div className="aspect-video grid place-items-center bg-muted rounded">{s.logo_url ? <img src={s.logo_url} alt={s.name} className="max-h-12" /> : <Crown className="h-8 w-8 text-muted-foreground" />}</div>
                <div className="font-display font-semibold mt-2 text-sm text-center">{s.name}</div>
              </Card>
            ))}
          </div>}
      </div>
    </div>
  );
}
